import { render, staticRenderFns } from "./BloodFilmPanel.vue?vue&type=template&id=646ac69e&scoped=true&"
import script from "./BloodFilmPanel.vue?vue&type=script&lang=js&"
export * from "./BloodFilmPanel.vue?vue&type=script&lang=js&"
import style0 from "./BloodFilmPanel.vue?vue&type=style&index=0&id=646ac69e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ac69e",
  null
  
)

export default component.exports